<template>
  <v-content>
    <v-row wrap>
      <v-col cols="12">
        <h1 class="display-1 layout">
          {{ $t("PRIVACY_HEADER") }}
        </h1>
      </v-col>
      <v-col cols="12" class="privacyContent">
        <div v-html="$t('PRIVACY_TEXT')"></div>
      </v-col>
    </v-row>
  </v-content>

</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {}
})
export default class Privacy extends BasicComponent {

  created() {

  }

  mounted() {
    this.trackPage("Datenschutz");
  }

}

</script>
<style lang="scss" scoped>

.layout {
  margin-top: 10px;
}

.privacyContent {
  margin-top: 25px;
}

</style>
<style lang="scss">

</style>
